import { PdsWidget } from './pds-widget';
import {SinglePopoverWidget} from './single-popover-widget';
import { pdsLogger } from './pds-logger';
import {PopperPlacement} from './popper-configuration';
import {pdsUtils} from './pds-utils';
import {LinkItem} from './interfaces/link-item';
import {PdsTooltip} from './pds-tooltip';
import {pdsI18n} from './pds-i18n';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('pop-over'), 'pds-pop-over.ts');

export class PdsPopOver extends SinglePopoverWidget {
  is = 'pds-pop-over';

  linkItems: Array<LinkItem>;

  //This is the text that shows up on the button. Not required when iconOnly === true.
  dataButtonText: string;

  id: string;

  //Default alignment of the popup panel.
  dataDefaultAlignment: PopperPlacement = 'bottom-start';

  /*
   * This input is only required when the button text
   * isn't descriptive enough to give the user
   * clarification on the intention of the button, OR
   * you just have an icon on the button.
   */
  dataButtonAriaText: string | null;

  //Optional: Provide the iconName when you want an icon to show up on the button.
  dataIconName: string  | null;

  // Button blend turns off the background and borders
  dataIsButtonBlend: string | null;

  dataTooltipText: string | null;

  dataHeaderName: string | null;

  dataTooltipDirection: PopperPlacement | null;

  // @Input()
  // inDialog = false;

  // @Input()
  // panelZIndex = 7000;

  dataLabelText: string;

  dataHelpText: string;

  // @Input()
  // customStyleNames: Array<string> = [];

  // panelPlacementLocator: HTMLElement | (() => HTMLElement);

  //This should be 'true' when inside the app-header-bar. The widget looks and sets this automatically,
  //but it can be overridden with this attribute.
  dataIsAppAction: 'true' | 'false' | null;

  //This should be 'true' when inside the wizard-header-bar. The widget looks and sets this automatically,
  //but it can be overridden with this attribute.
  dataIsWizardAction: 'true' | 'false' | null;

  //The context is passed in to the every one of the callback functions called in linkItems
  context: any | null;

  //The tooltip element reference. This is necessary because it gets removed from the DOM so it cannot be
  //searched for at just any time.
  tooltipElement: PdsTooltip | undefined;

  tooltipReferenceCallback: (tooltipElement: PdsTooltip) => void;

  //This is used to close the parent popover when a child menu item is clicked.
  parentPopOver: PdsPopOver | undefined;

  //This is called when the user clicks the button that opens up the popover.
  //It is passed into secondary PdsPopOver widgets so that other instances can be closed
  //when this instance is clicked to open up a secondary menu.
  popOverTriggerButtonCallback: (event: Event) => void | null;

  //This function is given as a callback into secondary popovers so that they can
  //close previously opened secondary menus.
  closePreviouslyOpenedSecondaryMenus: (event: Event) => void | null;

  properties = {
    id: {
      type: String
    },
    dataButtonText: {
      type: String,
      value: null
    },
    dataDefaultAlignment: {
      type: String,
      value: 'bottom-start',
      observer: 'updateDefaultAlignment'
    },
    dataButtonAriaText: {
      type: String,
      value: null
    },
    dataIconName: {
      type: String,
      value: null
    },
    dataIsButtonBlend: {
      type: String,
      value: 'false'
    },
    dataTooltipText: {
      type: String,
      value: null
    },
    dataHeaderName: {
      type: String,
      value: null
    },
    dataTooltipDirection: {
      type: String,
      value: 'bottom-start',
      observer: 'tooltipDirectionChanged'
    },
    dataLabelText: {
      type: String,
      value: null
    },
    dataHelpText: {
      type: String,
      value: null
    },
    dataIsAppAction: {
      type: String,
      value: null
    },
    dataIsWizardAction: {
      type: String,
      value: null
    },
    linkItems: {
      value: null
    },
    context: {
      value: null
    },
    parentPopOver: {
      value: null
    },
    popOverTriggerButtonCallback: {
      value: null
    },
    dataIsButtonMultiAction: {
      type: String,
      value: 'false'
    }
  };

  ready(): void {
    super.ready();
    this.tooltipReferenceCallback = (tooltipElement: PdsTooltip): void => {
      this.tooltipElement = tooltipElement;
    };

    this.createClosePreviouslyOpenedSecondaryMenus();
  }

  createClosePreviouslyOpenedSecondaryMenus(): void {
    this.closePreviouslyOpenedSecondaryMenus = (event: Event): void => {
      let eventPopover: HTMLElement | undefined = <HTMLElement | undefined> (<any>pdsUtils.getClosest(<HTMLElement>event.target, this.is));
      let popperContainer: HTMLElement = <HTMLElement>pdsUtils.getClosest(<HTMLElement>event.target, '.tippy-popper');
      for (let popover of Array.from(popperContainer.querySelectorAll(this.is))) {
        if (popover !== eventPopover) {
          (popover as any as PdsPopOver).hidePopover();
        }
      }
    };
  }

  attached(): void {
    super.attached();

    //We set set this automatically if not set explicitly
    if (this.dataIsAppAction == null) {
      if (pdsUtils.getClosest(this.asElement(), '.pds-app-actions') != null) {
        this.dataIsAppAction = 'true';
      }
    }

    //We set set this automatically if not set explicitly
    if (this.dataIsWizardAction == null) {
      if (pdsUtils.getClosest(this.asElement(), '.pds-wizard-actions') != null) {
        this.dataIsWizardAction = 'true';
      }
    }
  }

  isRequiredDataDefined(): boolean {
    return true;
  }

  //Gets the selector for the popover panel.  Used by the SinglePopoverWidget code.
  getPopoverSelector(): string {
    return '.pds-pop-over-panel';
  }

  getPopoverTriggerSelector(): string {
    return '.pds-pop-over-trigger-button';
  }

  log(message?: any, ...optionalParams: any[]): void {
    log.apply(window, arguments);
  }

  getDefaultAlignment(): PopperPlacement {
    return this.dataDefaultAlignment;
  }

  executeLinkItem(event: Event): void {
    let linkItem: LinkItem | undefined = this.extractProperty(event, 'button', 'linkItem');
    if (linkItem == null) {
      console.error('The LinkItem could not be found.');
      return;
    }

    if (linkItem.callback) {
      linkItem.callback(this.context);
    } else {
      console.error('link item id: ' + linkItem.id + ' must have a call back function.');
      //this.router.navigate([linkItem.route]);
    }

    // hide all child popovers  TODO: We will need to do this when we have child menus.
    //this.closeMenus();

    // hide this panel
    this.hidePopover();

    if (this.parentPopOver != null) {
      this.parentPopOver.hidePopover();
    }

    if (this.closePreviouslyOpenedSecondaryMenus != null) {
      this.closePreviouslyOpenedSecondaryMenus(event);
    }
  }

  /**
   * Called from the observer on dataDefaultAlignment
   */
  updateDefaultAlignment(): void {
    if (this.popoverInstance != null &&
        (<any>this.popoverInstance).options != null &&
        (<any>this.popoverInstance).popperInstance != null &&
        (<any>this.popoverInstance).popperInstance.options != null) {
      (<any>this.popoverInstance).options.placement = this.dataDefaultAlignment;
      (<any>this.popoverInstance).popperInstance.options.placement = this.dataDefaultAlignment;
    }
  }

  tooltipDirectionChanged(): void {
    if (this.tooltipElement != null) {
      this.tooltipElement.updateDefaultDirection(this.dataTooltipDirection);
    }
  }

  /**
   * Focuses on first clickable element of the popover panel.
   */
  focusInPanel(event: Event): void {
    //Run in a set timeout so the tippy stuff can finish manipulating the DOM first.
    setTimeout(() => {
      let panelSelector: string = '#' + this.id + '-pop-over-panel a, #' + this.id + '-pop-over-panel button';
      this.log('panelSelector: ' + panelSelector);
      let item: HTMLElement | null = document.querySelector(panelSelector);
      if (item != null) {
        item.focus();
      }
    });

    if (this.popOverTriggerButtonCallback != null) {
      this.popOverTriggerButtonCallback(event);
    }
  }

  hasIconAndTextClass(): 'pds-pop-over-has-icon-and-text' | '' {
    if (this.compare(this.dataButtonText, 'has-letters') && this.dataIconName != null) {
      return 'pds-pop-over-has-icon-and-text';
    }

    return '';
  }

  getLinkItemAriaLabel(linkItem: LinkItem, linkIndex: number): string | null {
    if (this.linkItems.length === 1) {
      return linkItem.name + '. ' + pdsI18n.getText('pds|popover|Navigating From Single Element');
    } else if (linkIndex === 0) {
      return linkItem.name + '. ' + pdsI18n.getText('pds|popover|Backwards From First Element');
    } else if (linkIndex === this.linkItems.length - 1) {
      return linkItem.name + '. ' + pdsI18n.getText('pds|popover|Forwards From Last Element');
    }

    return null;
  }
}
